import classNames from 'classnames';

import Tooltip from 'legacy/components/generic/Tooltip';

import { LimitedReportWarning as theme } from 'legacy/css-modules';

const LimitedReportWarning = ({ className, tooltip }) => {
  const Badge = (
    <span className={classNames(theme.LimitedReportWarning, className)}>
      <span className={theme.LimitedReportWarningText}>Limited Report</span>
    </span>
  );
  if (tooltip) {
    return (
      <Tooltip
        trigger={Badge}
        position="top"
        content="We don’t have sufficient data about this home to provide a HouseCanary value. You can still add more information about the home or select comps in Property Explorer."
        transparentScreen
      />
    );
  } else {
    return Badge;
  }
};

export default LimitedReportWarning;
